import React from "react";

export type InputProps = {
    id?: string;
    label?: string;
    width: string;
    type: string;
    placeholder?: string;
    extraClasses: string;
    required?: boolean;
    value?: string | boolean;
    checked?: boolean;
    onChange?: (name: string, value: string | boolean) => void;
    name: string;
    validMessage?: string;
    max?: string;
};

export default function Input({
    id,
    label,
    width,
    type,
    placeholder,
    extraClasses,
    required,
    value,
    checked,
    onChange,
    name,
    validMessage,
    max
}: InputProps) {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onChange) return;

        if (type === "checkbox") {
            onChange(name, e.target.checked);
        } else {
            onChange(name, e.target.value);
        }
    };

    return (
        <div className="form-group">
            {label && <label htmlFor={id || name}>{label}{required ? "*" : ""}</label>}
            <input
                id={id || name}
                className={`${extraClasses} w-${width} border rounded px-2`}
                type={type}
                placeholder={placeholder}
                required={required}
                onChange={handleInputChange}
                onInvalid={(e) =>
                    e.currentTarget.setCustomValidity(validMessage || `${label || name} is required`)
                }
                {...(max ? { max } : {})}
                {...(type === "checkbox"
                    ? { checked: Boolean(value) }
                    : { value: (value as string) ?? "" })}
            />
        </div>
    );
}
